import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { SpinningWheel } from './spinning-wheel';

export default createApp(
  { alias: meta.appAlias, name: meta.appName },
  SpinningWheel
);
